{{currentValue | number : isDecimal? '1.1-1': '1.0-0'}}{{showPercentSymbol ? "%" : ""}}
